import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)({
  flexShrink: 1,
  flexGrow: 0,
  minWidth: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
  maxWidth: '12rem',
});

interface CollapsableCardButtonProps extends Omit<ButtonProps, 'variant' | 'children'> {
  label: string;
}

const CollapsableCardButton = ({
  label,
  onClick,
  disabled,
  ...rest
}: CollapsableCardButtonProps) => {
  return (
    <StyledButton
      disableRipple
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {label}
    </StyledButton>
  );
};

export { CollapsableCardButton };